import _globalThis2 from "../internals/global-this";
import _fails from "../internals/fails";
import _environmentV8Version from "../internals/environment-v8-version";
import _environment from "../internals/environment";
var exports = {};
var _globalThis = _globalThis2;
var fails = _fails;
var V8 = _environmentV8Version;
var ENVIRONMENT = _environment;
var structuredClone = _globalThis.structuredClone;
exports = !!structuredClone && !fails(function () {
  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (ENVIRONMENT === "DENO" && V8 > 92 || ENVIRONMENT === "NODE" && V8 > 94 || ENVIRONMENT === "BROWSER" && V8 > 97) return false;
  var buffer = new ArrayBuffer(8);
  var clone = structuredClone(buffer, {
    transfer: [buffer]
  });
  return buffer.byteLength !== 0 || clone.byteLength !== 8;
});
export default exports;